// Libraries
import React, {useRef} from 'react'
import {
  Appearance,
  ComponentColor,
  ComponentSize,
  FlexBox,
  FlexDirection,
  InputLabel,
  Popover,
  PopoverInteraction,
  PopoverPosition,
  ToggleContainerRef,
  AlignItems,
  JustifyContent,
  Toggle,
  InputToggleType,
  IconFont,
} from '@influxdata/clockface'

// Components
import {LegalText} from './LegalText'

interface Props {
  isAgreeing: boolean
  isError: boolean
  onToggleAgree: () => void
}

const LegalCheckbox = ({
  isError,
  isAgreeing,
  onToggleAgree,
}: Props): JSX.Element => {
  const toggleRef = useRef<ToggleContainerRef>(null)

  return (
    <FlexBox
      direction={FlexDirection.Row}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.FlexStart}
      margin={ComponentSize.Large}
    >
      <Toggle
        id="serviceAgreement"
        testID="serviceAgreement--checkbox"
        containerRef={toggleRef}
        type={InputToggleType.Checkbox}
        checked={isAgreeing}
        icon={IconFont.CheckMark_New}
        name="serviceAgreement"
        className="legal-checkbox"
        size={ComponentSize.Large}
        tabIndex={0}
        onChange={onToggleAgree}
      />
      <InputLabel
        size={ComponentSize.Small}
        wrapText={true}
        style={{textAlign: 'left'}}
        active={isAgreeing}
      >
        <LegalText />
      </InputLabel>
      <Popover
        appearance={Appearance.Solid}
        position={PopoverPosition.Below}
        contents={() => (
          <div className="reminder-text">Don't forget this step</div>
        )}
        visible={isError}
        hideEvent={PopoverInteraction.None}
        showEvent={PopoverInteraction.None}
        color={ComponentColor.Success}
        triggerRef={toggleRef}
        distanceFromTrigger={10}
      />
    </FlexBox>
  )
}

export default LegalCheckbox
